import { useSuppliers } from "hooks/useDataFetch";
import MaterialTable from "@material-table/core";

import React from "react";
import { muiTable } from "utils";
import moment from "moment";
import { Avatar, Button } from "@mui/material";
import {
  Bolt,
  CreditCard,
  Edit,
  LocalAtm,
  LocalConvenienceStore,
  LocationOn,
  Public,
  RemoveRedEye,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const ViewSuppliers = () => {
  const { data, loading } = useSuppliers();

  const navigate = useNavigate();

  console.log(data);

  return (
    <main className="dashboard-user-manage">
      <MaterialTable
        title="Suppliers"
        isLoading={!data && loading}
        data={data || []}
        options={{ ...muiTable.options() }}
        style={muiTable.styles}
        columns={[
          {
            title: "#",
            field: "sl",
            width: "5%",
            editable: "never",
            id: "sl",
          },
          {
            title: "Image",
            field: "image",
            render: (rowData) => (
              <Avatar
                src={rowData.image || rowData.img}
                variant="rounded"
                sx={{ width: 60, height: 60 }}
              />
            ),
            width: "5%",
          },
          {
            title: "Name",
            field: "name",
            emptyValue: "Not Set",
          },
          {
            title: "Location",
            field: "location",
            render: ({ location }) => {
              return (
                <span className="flex-row align-items-center gap-1">
                  <LocationOn
                    sx={{
                      color: "#91227a",
                    }}
                  />
                  {location}
                </span>
              );
            },
          },
          {
            title: "Supplier Type",
            field: "supplierType",
            emptyValue: "Not Set",
            render: ({ supplierType }) => {
              return (
                <span className="flex-row align-items-center gap-1">
                  {supplierType === "international" && (
                    <>
                      {" "}
                      <Public
                        sx={{
                          color: "#2259c5",
                        }}
                      />{" "}
                      International{" "}
                    </>
                  )}
                  {supplierType === "local" && (
                    <>
                      {" "}
                      <LocalConvenienceStore
                        sx={{
                          color: "#2259c5",
                        }}
                      />{" "}
                      Local{" "}
                    </>
                  )}
                  {supplierType === "quickDelivery" && (
                    <>
                      {" "}
                      <Bolt
                        sx={{
                          color: "#2259c5",
                        }}
                      />{" "}
                      Quick{" "}
                    </>
                  )}
                </span>
              );
            },
          },
          {
            title: "Payments Type",
            field: "payments",
            render: (rowData) => {
              let cash = rowData?.payments?.cash;
              let card = rowData?.payments?.card;

              return (
                <div className="flex-row gap-2 align-items-center">
                  {cash && (
                    <LocalAtm
                      sx={{
                        color: "#7d7d7d",
                      }}
                    />
                  )}
                  {card && (
                    <CreditCard
                      sx={{
                        color: "#7d7d7d",
                      }}
                    />
                  )}
                </div>
              );
            },
          },
          {
            title: "Joined",
            field: "createdAt",
            type: "date",
            render: (rowData) => {
              return moment(rowData?.createdAt).fromNow();
            },
          },
          {
            title: "Total Sales",
            field: "totalSales",
            render: (rowData) => {
              return "SAR " + (rowData?.totalSales?.toFixed(2) || 0);
            },
          },
          {
            title: "Actions",
            render: (rowData) => {
              return (
                <div className="flex-row gap-1">
                  <Button
                    startIcon={<RemoveRedEye />}
                    className="view-supplier-btn"
                    onClick={() => {
                      // console.log(rowData);
                      navigate(`/admin/suppliers/viewdetails/${rowData?.id}`);
                    }}
                  >
                    View
                  </Button>
                  <Button
                    startIcon={<Edit />}
                    className="view-supplier-btn-edit"
                    onClick={() => {
                      // console.log(rowData);
                      navigate(`/admin/suppliers/edit/${rowData?.id}`);
                    }}
                  >
                    Edit
                  </Button>
                </div>
              );
            },
          },
        ]}
      />
    </main>
  );
};

export default ViewSuppliers;
